import React, { useMemo } from "react";
import ContractTemplateCard from "../components/contracts/ContractTemplateCard";
import { useHistory } from "react-router-dom";

import {
  Container,
  ScreenContainer,
  ScreenHeader,
  Button,
  Link,
} from "../components/wombat-ui";
import { ContractIcon } from "../components/icons";

import useTranslations from "../hooks/useTranslations";
import useViewer from "../hooks/useViewer";
import { H3 } from "../components/wombat-ui/components/Typography";

type ContractTemplateListScreenProps = {};

const ContractTemplateListScreen: React.FC<ContractTemplateListScreenProps> = ({}) => {
  const history = useHistory();
  const {
    company: { contractTemplates },
    isCapableOfInsertingContractTemplates
  } = useViewer();

  const t = useTranslations();

  const defaultContracts = useMemo(
    () => contractTemplates.filter((contract) => contract.default),
    [contractTemplates]
  );

  const myContracts = useMemo(
    () => contractTemplates.filter((contract) => !contract.default),
    [contractTemplates]
  );

  return (
    <ScreenContainer loading={!contractTemplates}>
      <ScreenHeader
        title={t("contracts.contractTemplates") as string}
        description={t("contracts.contractTemplatesDescription") as string}
        icon={ContractIcon}
        actions={[
          isCapableOfInsertingContractTemplates && (
            <Link to="/contracts/templates/new" variant="button" key="new">
              {t("contracts.createTemplate")}
            </Link>
          )
        ]}
      />
      <Container className="flex flex-col space-y-10">
        {defaultContracts.length > 0 && (
          <div>
            <div className="pb-8">
              <H3
                description={t(
                  "contracts.defaultContractTemplatesListDescription"
                )}
              >
                {t("contracts.defaultContractTemplatesList")}
              </H3>
            </div>
            <div className="grid gap-8 px-0 overflow-x-auto grid-cols-scrollable lg:grid-cols-4">
              {defaultContracts.map((contract) => (
                <ContractTemplateCard contract={contract} key={contract.id} />
              ))}
            </div>
          </div>
        )}
        {myContracts.length > 0 && (
          <div>
            <div className="pb-8">
              <H3 description={t("contracts.templatesListDescription")}>
                {t("contracts.templatesList")}
              </H3>
            </div>
            <div className="grid gap-8 px-0 overflow-x-auto grid-cols-scrollable lg:grid-cols-4">
              {myContracts.map((contract) => (
                <ContractTemplateCard contract={contract} key={contract.id} />
              ))}
            </div>
          </div>
        )}
      </Container>
    </ScreenContainer>
  );
};

export default React.memo(ContractTemplateListScreen);
